module.exports = __webpack_public_path__ + "assets/img/pinzhi.bda6e61b.png";